export const getSeatCategoriesStatistics = (seats, allocatedSeatIds) => {
    return seats.reduce((acc, seat) => {
        if (!seat.category) {
            return acc;
        }

        if (!acc[seat.category.id]) {
            acc[seat.category.id] = { allocated: 0, free: 0, capacity: 0 };
        }

        acc[seat.category.id].capacity++;
        if (allocatedSeatIds.has(seat.id)) {
            acc[seat.category.id].allocated++;
        } else {
            acc[seat.category.id].free++;
        }

        return acc;
    }, {});
};
